import { ACTION_TYPES } from '../constants/actionTypes/results';
import { resultTypes } from '../../appSettings';

const resultsReducer = (state, action) => {
  const reducedState = {
    loadingAll: true,
    resultsCount: {
      total: null,
      [resultTypes.HOTELS]: null,
      [resultTypes.DESTINATIONS]: null,
      [resultTypes.EXCURSIONS]: null,
      [resultTypes.GROUP_TRIPS]: null,
    },
    [resultTypes.HOTELS]: [],
    [resultTypes.DESTINATIONS]: [],
    [resultTypes.EXCURSIONS]: [],
    [resultTypes.GROUP_TRIPS]: [],
    serializedComponents: [],
    getSerializedComponents: false,
    ...state,
  };

  switch (action.type) {
    case ACTION_TYPES.SET_RESULTS_COUNT_TOTAL:
      return {
        ...reducedState,
        resultsCount: {
          ...reducedState.resultsCount,
          total: action.payload.total,
        },
      };

    case ACTION_TYPES.SET_LIST_COUNT:
      return {
        ...reducedState,
        listCount: action.payload.listCount,
      };

    case ACTION_TYPES.SET_SERIALIZED_COMPONENT:
      return {
        ...reducedState,
        serializedComponents: [
          ...reducedState.serializedComponents,
          action.payload.serializedComponent,
        ],
      };

    case ACTION_TYPES.SET_SELECTED_RESULT_HEADER:
      return {
        ...reducedState,
        selectedResultHeader: action.payload.selectedResultHeader,
      };

    case ACTION_TYPES.GET_RESULT_HOTELS:
      return {
        ...reducedState,
        loadingHotels: true,
      };

    case ACTION_TYPES.GET_RESULT_HOTELS_ERROR:
      return {
        ...reducedState,
        loadingHotels: false,
      };

    case ACTION_TYPES.GET_RESULT_HOTELS_SUCCESS:
      return {
        ...reducedState,
        [resultTypes.HOTELS]: action.payload.hotels,
        resultsCount: {
          ...reducedState.resultsCount,
          [resultTypes.HOTELS]: action.payload.hits,
        },
        loadingHotels: false,
      };

    case ACTION_TYPES.GET_RESULT_DESTINATIONS:
      return {
        ...reducedState,
        loadingDestinations: true,
      };

    case ACTION_TYPES.GET_RESULT_DESTINATIONS_ERROR:
      return {
        ...reducedState,
        loadingDestinations: false,
      };

    case ACTION_TYPES.GET_RESULT_DESTINATIONS_SUCCESS:
      return {
        ...reducedState,
        [resultTypes.DESTINATIONS]: action.payload.destinations,
        resultsCount: {
          [resultTypes.DESTINATIONS]: action.payload.hits,
        },
        loadingDestinations: false,
      };
    case ACTION_TYPES.GET_RESULT_EXCURSIONS:
      return {
        ...reducedState,
        loadingExcursions: true,
      };

    case ACTION_TYPES.GET_RESULT_EXCURSIONS_ERROR:
      return {
        ...reducedState,
        loadingExcursions: false,
      };

    case ACTION_TYPES.GET_RESULT_EXCURSIONS_SUCCESS:
      return {
        ...reducedState,
        [resultTypes.EXCURSIONS]: action.payload.excursions,
        resultsCount: {
          [resultTypes.EXCURSIONS]: action.payload.hits,
        },
        loadingExcursions: false,
      };
    case ACTION_TYPES.GET_RESULT_GROUP_TRIPS:
      return {
        ...reducedState,
        loadingGroupTrips: true,
      };

    case ACTION_TYPES.GET_RESULT_GROUP_TRIPS_ERROR:
      return {
        ...reducedState,
        loadingGroupTrips: false,
      };

    case ACTION_TYPES.GET_RESULT_GROUP_TRIPS_SUCCESS:
      return {
        ...reducedState,
        [resultTypes.GROUP_TRIPS]: action.payload.groupTrips,
        resultsCount: {
          [resultTypes.GROUP_TRIPS]: action.payload.hits,
        },
        loadingGroupTrips: false,
      };

    case ACTION_TYPES.GET_RESULT_ALL:
      return {
        ...reducedState,
        loadingAll: true,
      };

    case ACTION_TYPES.GET_RESULT_SERIALIZED_COMPONENTS:
      return {
        ...reducedState,
        getSerializedComponents: true,
        loadingAll: false,
      };

    case ACTION_TYPES.GET_RESULT_ALL_ERROR:
      return {
        ...reducedState,
        loadingAll: false,
      };

    case ACTION_TYPES.GET_RESULT_ALL_SUCCESS:
      return {
        ...reducedState,
        [resultTypes.HOTELS]: action.payload[resultTypes.HOTELS],
        [resultTypes.DESTINATIONS]: action.payload[resultTypes.DESTINATIONS],
        [resultTypes.EXCURSIONS]: action.payload[resultTypes.EXCURSIONS],
        [resultTypes.GROUP_TRIPS]: action.payload[resultTypes.GROUP_TRIPS],
        [resultTypes.ARTICLES]: action.payload[resultTypes.ARTICLES],
        resultsCount: {
          total: action.payload.totalHits,
          [resultTypes.HOTELS]: action.payload.hotelHits,
          [resultTypes.DESTINATIONS]: action.payload.destinationHits,
          [resultTypes.EXCURSIONS]: action.payload.excursionHits,
          [resultTypes.GROUP_TRIPS]: action.payload.groupTripHits,
          [resultTypes.ARTICLES]: action.payload.articleHits,
        },
        loadingAll: false,
      };
    case ACTION_TYPES.SET_NEVER_SHOW_REMINDER:
      return {
        ...reducedState,
        neverShowReminder: true,
      };
    default:
      return { ...reducedState };
  }
};

export default resultsReducer;
